export default[
    {
        path: '/dataList/memberDataAnalysis',
        component: resolve => require(['../page.vue'], resolve),
        meta: {
            title: '会员分析',
            authLogin: true
        }
    }
]